/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import * as types from '../constants/ActionTypes';
import {Utils} from '../components/Utils';
import {env} from '../constants/env';

Utils.init('actions');


export const getLogin = (username, password) => ({
    type: types.REQUEST_LOGIN,
    username,
    password,
});

export const receiveLogin = (login) => ({
    type: types.RECEIVE_LOGIN,
    login,
});

export const errorLoginConnection = () => ({
    type: types.ERROR_LOGIN_CONNECTION,
});

export const errorLoginLogin = () => ({
    type: types.ERROR_LOGIN_LOGIN,
});

export const resetErrorLogin = () => ({
    type: types.RESET_ERROR_LOGIN,
});

export const requestLogout = () => ({
    type: types.REQUEST_LOGOUT,
});

export function doLogin(username, password) {
    return function(dispatch) {
        dispatch(getLogin(username, password));

        Utils.log('actions', 'doLogin');

        let dataURL = env.apiUrl + '/usersApi/v1/loginUser?username=' + username + '&password=' + password;
        // return fetch(dataURL, {headers: new Headers({'Access-Control-Allow-Origin': '*'})})
        return fetch(dataURL)
            .then(
                (response) => response.json(),
                (error) => {
                    throw new TypeError(error);
                }
            )
            .then((login) => {
                if (login.logged === undefined || login.logged === false ||
                   (!login.groupname.includes('GEK') && !login.groupname.includes('SYS'))) {
                    dispatch(errorLoginLogin());
                } else {
                    dispatch(receiveLogin(login));
                }
            })
            .catch((error) => {
                    Utils.errobj('ACTIONS', 'doLogin', error);
                    dispatch(errorLoginConnection());
                }
            );
    };
}



// WEBPACK FOOTER //
// ./src/actions/login.js